"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DnpClassificationGate = exports.DnpClassificationOutcome = void 0;
const altiumProjectFileUtil_1 = require("../Parse/Altium/parsers/project/altiumProjectFileUtil");
var DnpClassificationOutcome;
(function (DnpClassificationOutcome) {
    DnpClassificationOutcome["SkippedParserFlagPresent"] = "skipped_parser_flag_present";
    DnpClassificationOutcome["SkippedCadTool"] = "skipped_cad_tool";
    DnpClassificationOutcome["SkippedNoModules"] = "skipped_no_modules";
    DnpClassificationOutcome["NoCandidates"] = "no_candidates";
    DnpClassificationOutcome["Classified"] = "classified";
})(DnpClassificationOutcome || (exports.DnpClassificationOutcome = DnpClassificationOutcome = {}));
class DnpClassificationGate {
    static { this.CAD_TOOLS = new Set([
        'orcad',
        'eagle',
    ]); }
    static { this.CLASSIFY_UNAPPLIED_ALTIUM_VARIANTS = false; }
    static skipReason(cadTool, modules, cadTools = DnpClassificationGate.CAD_TOOLS, classifyUnappliedAltiumVariants = DnpClassificationGate.CLASSIFY_UNAPPLIED_ALTIUM_VARIANTS) {
        if (modules.length === 0) {
            return DnpClassificationOutcome.SkippedNoModules;
        }
        if (modules.some((module) => module.isDnp === true)) {
            return DnpClassificationOutcome.SkippedParserFlagPresent;
        }
        if (!cadTools.has(cadTool) &&
            !(classifyUnappliedAltiumVariants && DnpClassificationGate.hasUnappliedNotFittedVariant(cadTool, modules))) {
            return DnpClassificationOutcome.SkippedCadTool;
        }
        return null;
    }
    static hasUnappliedNotFittedVariant(cadTool, modules) {
        return (cadTool === 'altium' &&
            modules.some((module) => Object.entries(module.metadata ?? {}).some(([key, value]) => key.startsWith(altiumProjectFileUtil_1.AltiumProjectFileUtil.UNAPPLIED_VARIANT_COLUMN_PREFIX) &&
                value === altiumProjectFileUtil_1.AltiumProjectFileUtil.NOT_FITTED_LABEL)));
    }
}
exports.DnpClassificationGate = DnpClassificationGate;
//# sourceMappingURL=dnp-classification-gate.js.map